// eslint-disable-next-line react-hooks/exhaustive-deps

import { Box, Text, HStack, Grid, GridItem } from "@chakra-ui/react";
import React, { useEffect } from "react";
import PaginatedInstantLoan from "../components/PaginatedInstantLoan";
import moment from "moment";
import Loader from "../components/Loader/loader";
import { useSelector, useDispatch } from "react-redux";
import { getInstantLoanRequestAction } from "../redux/reducers/instantLoanRequestReducer";
import FilterComponent from "../components/Inputs/FilterComponent";
import { getInstantLoanRequests } from "../services/axios";
import { convertArrayOfObjectsToWorksheet } from "../services/utils/helpersFunc";

function InstantLoan() {
  const dispatch = useDispatch();
  const { instantLoans, meta, loading } = useSelector(
    (state) => state.instantLoanRequest
  );

  const [filters, setFilters] = React.useState({
    page: 1,
    pageLimit: 50,
  });

  useEffect(() => {
    dispatch(getInstantLoanRequestAction(filters));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, filters]);

  const downloadHandler = async () => {
    const res = await getInstantLoanRequests({ ...filters, exportData: true });
    if (res) {
      return convertArrayOfObjectsToWorksheet(
        res?.data,
        `Instant Loans Report-${moment().format("LLL")}`
      );
    }
  };
  return (
    <Box
      bg="#F8F9FC"
      p={["20px 10px", "20px 10px", "20px 10px 20px 30px"]}
      h="100vh"
      w="100%"
    >
      <Text
        color="#5B2E4F"
        fontSize="18px"
        fontWeight="500"
        fontFamily="satoshiBold"
      >
        Instant Loans
      </Text>

      <Grid templateColumns="repeat(5, 1fr)" gap={6}>
        <GridItem>
          <HStack
            justify="space-between"
            bg="#F8F1F6"
            borderRadius="6px"
            p="20px"
            marginTop="5"
          >
            <Box>
              <Text
                fontSize={["13px", "15px"]}
                color="#33343D"
                fontWeight="500"
                fontFamily="satoshiBold"
              >
                Number of Loans Requested
              </Text>
              <Text
                fontSize="21px"
                fontFamily="satoshiBolder"
                color="#5B2E4F"
                lineHeight="28.35px"
              >
                {meta?.totalVolume || 0}
              </Text>
            </Box>
          </HStack>
        </GridItem>
      </Grid>

      <Box mt="20px">
        <Text
          color="#33343D"
          fontSize="15px"
          fontWeight="700"
          fontFamily="satoshiBolder"
        >
          Loan Requests
        </Text>

        <FilterComponent
          filters={filters}
          setFilters={setFilters}
          downloadHandler={downloadHandler}
        />

        <PaginatedInstantLoan instantLoans={instantLoans} meta={meta} />

        {loading && (
          <Box
            display={"flex"}
            justify={"center"}
            alignItems={"center"}
            justifyContent={"center"}
            marginTop={"20"}
          >
            <Loader />
          </Box>
        )}

        {!loading && instantLoans?.length === 0 && (
          <Box
            display={"flex"}
            justify={"center"}
            alignItems={"center"}
            justifyContent={"center"}
            marginTop={"20"}
          >
            <Text>No Instant Loan Currently Available </Text>
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default InstantLoan;
